import { useUser } from "./useUser";

export function useUserTimezone() {
  const { data: user } = useUser();

  const userTimezone = user?.user?.timezone;

  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return {
    browserTimezone,
    hasUserTimezone: !!userTimezone,
    timezone: userTimezone || browserTimezone,
    userTimezone,
  };
}
